// Webfuture.jsx
import React, { useEffect, useRef, useState } from "react";
import "../Style/Webfuture.css";

import iconUser from "../assets/C.png";
import iconWireframe from "../assets/F.png";
import iconModernUI from "../assets/B.png";
import iconMobile from "../assets/M.png";
import iconUsability from "../assets/P.png";

const services = [
  {
    id: 1,
    icon: iconUser,
    alt: "Custom Website Development",
    title: "Custom Website Development",
    text: "We build fully customized websites tailored to your business goals, delivering scalable, secure, and feature-rich solutions with exceptional user experiences.",
    row: "top",
  },
  {
    id: 2,
    icon: iconWireframe,
    alt: "Frontend Development",
    title: "Frontend Development",
    text: "Our frontend developers create fast, responsive, and interactive user interfaces using modern technologies that ensure seamless navigation across all devices.",
    row: "top",
  },
  {
    id: 3,
    icon: iconModernUI,
    alt: "Backend Development",
    title: "Backend Development",
    text: "We develop robust backend systems that power your website with secure databases, APIs, business logic, and scalable architecture for long-term performance.",
    row: "top",
  },
];

const Webfuture = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`webfuture-main-section ${isVisible ? "webfuture-visible" : ""}`}
      ref={sectionRef}
    >
      <div className="webfuture-glow webfuture-glow-1" aria-hidden="true" />
      <div className="webfuture-glow webfuture-glow-2" aria-hidden="true" />

      <div className="webfuture-main-container">
        <span className="webfuture-eyebrow webfuture-anim webfuture-anim-0">
          Our Approach
        </span>

        {/* Heading */}
        <h1 className="webfuture-main-title webfuture-anim webfuture-anim-1">
          The Future of Web Development
        </h1>

        {/* Delivered by */}
        <p className="webfuture-subtitle-label webfuture-anim webfuture-anim-2">
          Delivered by MPeoples
        </p>

        {/* Description */}
        <p className="webfuture-main-description webfuture-anim webfuture-anim-3">
          Modern websites are more than digital brochures—they are powerful
          business tools that generate leads, improve customer engagement, and
          accelerate growth. At MPeoples, we combine cutting-edge technologies,
          responsive design, SEO best practices, and scalable development to
          build secure, high-performance websites that help businesses succeed
          in today's competitive digital landscape.
        </p>

        {/* Cards Grid */}
        <div className="webfuture-card-grid">
          {/* Top row — 3 cards */}
          {services
            .filter((s) => s.row === "top")
            .map((service, i) => (
              <div
                key={service.id}
                className={`webfuture-service-card webfuture-anim webfuture-anim-${4 + i}`}
              >
                <div className="webfuture-card-header">
                  <div className="webfuture-card-icon-wrap">
                    <img
                      src={service.icon}
                      alt={service.alt}
                      className="webfuture-card-icon"
                    />
                  </div>
                  <h3 className="webfuture-card-title">{service.title}</h3>
                </div>
                <p className="webfuture-card-text">{service.text}</p>
              </div>
            ))}

          {/* Bottom row — 2 cards */}
          <div className="webfuture-service-card webfuture-card-bottom-left webfuture-anim webfuture-anim-7">
            <div className="webfuture-card-header">
              <div className="webfuture-card-icon-wrap">
                <img
                  src={iconMobile}
                  alt="Mobile-First & Responsive Design"
                  className="webfuture-card-icon"
                />
              </div>
              <h3 className="webfuture-card-title">
                Mobile-First &amp; Responsive Design
              </h3>
            </div>
            <p className="webfuture-card-text">
              Every website is optimized for smartphones, tablets, laptops, and
              desktops, ensuring a consistent and engaging experience across all
              screen sizes.
            </p>
          </div>

          <div className="webfuture-service-card webfuture-card-bottom-right webfuture-anim webfuture-anim-8">
            <div className="webfuture-card-header">
              <div className="webfuture-card-icon-wrap">
                <img
                  src={iconUsability}
                  alt="Performance Optimization & Security"
                  className="webfuture-card-icon"
                />
              </div>
              <h3 className="webfuture-card-title">
                Performance Optimization &amp; Security
              </h3>
            </div>
            <p className="webfuture-card-text">
              We improve website speed, Core Web Vitals, security, and overall
              performance using industry best practices to maximize SEO rankings
              and user satisfaction.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Webfuture;